import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Stack, Button, Typography, styled } from "@mui/material";
import { IconButton } from "@mui/material";
import { ReactComponent as CloseOutlined } from "../../assets/icons/close_icon.svg";
import { useDispatch } from "react-redux";
import { doRemoveUser } from "../../reducers/user/user.service";
import { useNavigate } from "react-router-dom";
import { removeAccessToken } from "../../reducers/auth/auth.slice";
import { doLogout } from "../../reducers/auth/auth.service";
import { enqueueSnackbar } from "notistack";
import { clearUserData } from "../../reducers/user/user.slice";

const Image = styled("img")``;

const ConfirmationDialog = ({
  open,
  handleDialogClose,
  title,
  description,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Dialog
      scroll="body"
      open={open}
      onClose={handleDialogClose}
      disableScrollLock={false}
      slotProps={{
        paper: {
          component: "form",
          sx: {
            p: {
              xs: "15px !important",
              sm: "30px !important",
            },
            paddingInline: { lg: "50px !important" },
            borderRadius: { xs: "20px !important", sm: "50px !important" },
            width: "fit-content",
          },
        },
      }}
    >
      <DialogTitle
        variant="h3"
        sx={{
          textAlign: "center",
          p: 0,
          mt: "15px",
          fontWeight: 700,
        }}
      >
        {title}
      </DialogTitle>

      <Typography
        sx={{
          color: "white",
          textAlign: "center",
          fontFamily: "secondaryFontFamily",
          fontSize: "14px",
          fontWeight: 300,
          mb: "30px",
        }}
      >
        {description}
      </Typography>

      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: "absolute",
          right: { sm: 20, xs: 10 },
          top: { sm: 20, xs: 10 },
          fontSize: "25px",
          color: "#999999",
        }}
      >
        <CloseOutlined />
      </IconButton>
      <Stack
        direction={"row"}
        gap={3}
        sx={{ justifyContent: "center", mt: "20px" }}
      >
        <Button
          autoFocus
          variant="contained"
          onClick={() => handleDialogClose()}
          sx={{
            mb: "15px",
            width: "150px",
            p: "5px 15px 2px 15px !important",
          }}
        >
          {title.includes("Cancel") ? "Ok" : "Cancel"}
        </Button>
        {title.includes("Cancel") ? null : (
          <Button
            variant="contained"
            onClick={async () => {
              if (title.includes("LOGOUT")) {
                const resultAction = await dispatch(doLogout({}));
                if (doLogout.fulfilled.match(resultAction)) {
                  enqueueSnackbar("Logout successful", {
                    variant: "success",
                  });
                  handleDialogClose();
                  navigate("/");
                } else {
                  enqueueSnackbar("Error logging out", {
                    variant: "error",
                  });
                }
              } else {
                const responseValue = await dispatch(doRemoveUser());
                if (doRemoveUser.fulfilled.match(responseValue)) {
                  await dispatch(clearUserData());
                  enqueueSnackbar("Account deleted successfully", {
                    variant: "success",
                  });
                  await dispatch(removeAccessToken());
                  handleDialogClose();
                  navigate("/");
                } else {
                  enqueueSnackbar("Error deleting account", {
                    variant: "error",
                  });
                }
              }
            }}
            sx={{
              mb: "15px",
              width: "150px",
              p: "3px 20px 0px 20px !important",
              bgcolor: title.includes("LOGOUT") ? "primary.main" : "red",
            }}
          >
            {title.includes("LOGOUT") ? "Logout" : "Delete account"}
          </Button>
        )}
      </Stack>
    </Dialog>
  );
};

export default ConfirmationDialog;
